module.exports = __webpack_public_path__ + "img/10.c8a5ee84.png";